"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductCategoryChangeProcess_1 = require("../model/ProductCategoryChangeProcess");

var ProductCategoryChangeProcessConverter_1 = require("./ProductCategoryChangeProcessConverter");
/**
 * Default implementation of {@link ProductCategoryChangeProcessConverter}.
 *
 * @author Radek Beran
 */


var ProductCategoryChangeProcessConverterImpl =
/*#__PURE__*/
function (_ProductCategoryChang) {
  _inherits(ProductCategoryChangeProcessConverterImpl, _ProductCategoryChang);

  function ProductCategoryChangeProcessConverterImpl() {
    _classCallCheck(this, ProductCategoryChangeProcessConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryChangeProcessConverterImpl).apply(this, arguments));
  }

  _createClass(ProductCategoryChangeProcessConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductCategoryChangeProcess_1.ProductCategoryChangeProcess(conversions.documentToClassId(source), conversions.toDate(source.transferCreated), conversions.asObjectList(source, 'processedByTasks', function (v) {
        return v;
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        transferCreated: conversions.fromDate(source.transferCreated),
        processedByTasks: conversions.asObjectArray(source, 'processedByTasks', function (task) {
          return task;
        })
      });
      return result;
    }
  }]);

  return ProductCategoryChangeProcessConverterImpl;
}(ProductCategoryChangeProcessConverter_1.ProductCategoryChangeProcessConverter);

exports.ProductCategoryChangeProcessConverterImpl = ProductCategoryChangeProcessConverterImpl;